import { create } from 'zustand'

/**
 * Global cache for the backend `/me` response.
 *
 * Shape (from backend schema): { id, token, email, auth0_id, profile_image_url }
 */
export const useMeStore = create(set => ({
  me: null,
  setMe: me => set({ me }),
  clearMe: () => set({ me: null }),
}))